import React from 'react';

import SelectRectangleBlock from "./SelectRectangleBlock";

const ChooseOrientation = [
    {orientation: "Hétéro", value: 1},
    {orientation: "Homo", value: 3},
    {orientation: "Bi", value: 2}
];

const AskOrientation = (props) => (
    <div id={"askOrientation"}>
        <div className={"row wrap"}>
            {props.gender === 3 && props.currentQuestion === 2 && (
                <div className={`gender-title him`}>
                    Lui
                </div>
            )}
            {((props.gender === 3 && props.currentQuestion === 3) || props.gender === 4) && (
                <div className={`gender-title her`}>
                    Elle
                </div>
            )}
            {props.gender === 5 && (
                <div className={`gender-title him`}>
                    Lui
                </div>
            )}
        </div>
        <div
            className={`gender-orientation ${(props.gender === 3 || props.gender === 4 || props.gender === 5) ? "" : "single"}`}>
            {ChooseOrientation.map((item, index) => (
                <SelectRectangleBlock key={index}
                                      isActive={props.singleOrientation ? props.orientation1 === item.value : props.orientation2 === item.value}
                                      onClick={() => props.handleBlockSelection(item.value, props.singleOrientation ? "orientation1" : "orientation2")}>
                    {item.orientation}
                </SelectRectangleBlock>
            ))}
        </div>

    </div>
);


export default AskOrientation;